import { useQueries, useQueryClient } from 'react-query';
import { getOrderByCheckId } from './useOrder';

export const useCheckDetails = (merchantId: string, checkIds: string[]) => {
  const queryClient = useQueryClient();

  const queries = useQueries(
    (checkIds || []).map((checkId) => ({
      queryKey: ['order', merchantId, checkId],
      queryFn: () => getOrderByCheckId(merchantId, checkId),

      enabled: !!merchantId && !!checkId,

      refetchInterval: 300000, // every 5 seconds
      refetchOnWindowFocus: true,
      staleTime: 300000,
    }))
  );

  const refetchAll = async () => {
    return await Promise.all(queries.map((q) => q.refetch()));
  };

  const invalidateAll = () => {
    checkIds.forEach((checkId) => {
      queryClient.invalidateQueries(['order', merchantId, checkId]);
    });
  };

  return {
    checks: queries.map((q) => q.data).filter(Boolean) as IOrder[],
    isLoading: queries.some((q) => q.isLoading),
    isError: queries.some((q) => q.isError),

    // expose controls
    refetchAll,
    invalidateAll,
  };
};
